export default __webpack_public_path__ + "static/media/ic_sensor.1263ca54.png";